export default __webpack_public_path__ + "static/media/o.99ef2962.mp4";